import styled, { css } from 'styled-components';

type LinkProps = {
  active?: boolean;
};

export const List = styled.ul`
  height: 72px;
  list-style: none;

  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 32px;

  @media (max-width: 900px) {
    height: auto;

    flex-direction: column;
    align-items: flex-start;

    gap: 9px;

    margin-top: 44px;
  }
`;

export const Link = styled.li<LinkProps>`
  ${({ active }) => css`
    border-bottom: ${active ? '4px solid #004f92' : 'none'};

    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    p {
      font-size: 16px;
      font-weight: ${active ? '600' : '500'};
      line-height: 24px;
      color: ${active ? '#004F92' : '#898B8E'};
      text-decoration: none;

      margin-top: ${active ? '4px' : '0'};
    }

    @media (max-width: 900px) {
      border-bottom: none;
      border-left: ${active ? '4px solid #004f92' : 'none'};
      height: 40px;

      display: flex;
      align-items: center;

      padding-left: ${active ? '28px' : '32px'};
    }
  `}
`;
